import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  Technician,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}technician/${COMMON_QUERY_PARAMS.TECHNICIAN_ID}`;

export const getTechnicianByIdQuery = async ({
  technicianId,
  sellerId,
}: {
  technicianId: string;
  sellerId: string;
}): Promise<BackResponse<Technician> | BackResponseFailure> => {
  try {
    const url = buildUrl(
      ENDPOINT.replace(COMMON_QUERY_PARAMS.TECHNICIAN_ID, technicianId),
      { sellerId },
    );

    return await apiCall<BackResponse<Technician>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default getTechnicianByIdQuery;
